import { endpoints } from 'api/endpoints'
import { GetArrayResponse } from 'interfaces/api.interfaces'
import { MlEngineOption } from 'interfaces/api/projectMl.interfaces'
import { axios } from 'modules/axios'

const getHosts = async (): GetArrayResponse<string> => {
  const { data: response } = await axios.request<string[]>({
    method: 'GET',
    url: endpoints.mlSettings.getHosts(),
  })
  return response
}

const getEndpoints = async (): GetArrayResponse<string> => {
  const { data: response } = await axios.request<string[]>({
    method: 'GET',
    url: endpoints.mlSettings.getEndpoints(),
  })
  return response
}

const getEngines = async (): GetArrayResponse<MlEngineOption> => {
  const { data: response } = await axios.request<MlEngineOption[]>({
    method: 'GET',
    url: endpoints.mlSettings.getEngines(),
  })
  return response
}

export const mlSettingsApi = {
  getHosts,
  getEndpoints,
  getEngines,
}
